const searchQuery = (searchBar)=>{
    let body = document.body;
    let resultsWrapper = document.querySelector('.predictive-search-container')
    let resultsContainer = resultsWrapper.querySelector('.inner');
    const section_name = 'gb-predictive-search';
    resultsContainer.innerHTML = '';
    resultsWrapper.classList.remove('active');
    body.classList.remove('fixed');
    var promises = [
        fetch(`/search/suggest?q="${encodeURI(searchBar.value)}"&resources[type]=collection,article,page&section_id=${section_name}&resources[options][fields]=title,tag,variants.title,variants.sku,body,product_type`),
        fetch(`/search?q=${encodeURI(searchBar.value)}&type=product&view=predictive`)
    ]
    Promise.all(promises)
        .then((responses) => {
            return Promise.all(responses.map(r => r.text()))
        })
        .then((texts) => {
            const resultsMarkupMain = new DOMParser()
                .parseFromString(texts[0], 'text/html')
                .querySelector(`#shopify-section-${section_name}`).innerHTML;

            const resultsProducts = new DOMParser()
                .parseFromString(texts[1], 'text/html')
                .querySelector(`body`).innerHTML;

            resultsContainer.innerHTML = resultsMarkupMain;
            resultsContainer.querySelector('.search-products').innerHTML = resultsProducts
            resultsWrapper.classList.add('active');
            body.classList.add('fixed');
            document.dispatchEvent(new CustomEvent('search-done'))
        })
        .catch((error) => {
            console.error(error);
        });
}

document.addEventListener('DOMContentLoaded', () => {
    let searchBars = document.querySelectorAll('.search-trigger');
    let body = document.body;
    let resultsWrapper = document.querySelector('.predictive-search-container')
    let resultsContainer = resultsWrapper.querySelector('.inner');

    searchBars.forEach(searchBar => {

        // Site search using predictive search api
        const predictiveSearchCallBack = () => {
            if (searchBar.value.length > 2) {
                if(window.predictiveSearchDebounce != null){
                    clearTimeout(window.predictiveSearchDebounce)
                }
                window.predictiveSearchDebounce = setTimeout(()=>{searchQuery(searchBar)},100)
            } else {
                resultsContainer.innerHTML = '';
                resultsWrapper.classList.remove('active');
                body.classList.remove('fixed');
            }
        }

        let searchMethod = predictiveSearchCallBack;

        if (searchBar && resultsContainer) {
            searchBar.addEventListener('keyup', searchMethod)
            let closeButton = resultsWrapper.querySelector('.close');
            let searchTrigger = document.querySelector('.mega-menu .mega-menu-controls [data-open-search]');
            let search = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper');
            let searchInput = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper .search-bar-qf input');
            closeButton.addEventListener('click', () => {
                resultsWrapper.classList.remove('active');
                body.classList.remove('fixed');
                searchInput.value = '';
                if (searchTrigger.classList.contains('active')) {
                    searchTrigger.classList.remove('active');
                    search.classList.remove('active');

                }

            })
        }
    })

})